import { useMe } from './useMe';
import type { User } from '../types';

interface UseAuthResult {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  // Erro ao verificar a sessão que NÃO é "deslogado" (ex.: 429, 5xx, rede).
  error: unknown;
}

export function useAuth(): UseAuthResult {
  const { data: user, isPending, error } = useMe();

  return {
    user: user ?? null,
    isAuthenticated: !!user,
    isLoading: isPending,
    error: error ?? null,
  };
}
